import isPartOfTour from '../../../utils/isPartOfTour/isPartOfTour';

import { Pano } from '../../../types/carousel';
import { Tour } from '../../../types';
import { ViewerURLParam } from '../../types/ViewerURLParam';

export const getInitialPanoId = (
  carouselIndex: number,
  startPano: string | undefined,
  carouselPanos: Pano[],
  tour?: Tour
) => {
  const params = new URLSearchParams(window.location.search);

  const customInitialPanoId = params.get(ViewerURLParam.PANO);

  if (!isNaN(carouselIndex)) {
    return carouselPanos[carouselIndex].panoid;
  }

  if (customInitialPanoId && tour && isPartOfTour(customInitialPanoId, tour)) {
    return customInitialPanoId;
  }

  if (carouselPanos.some((pano) => pano.panoid === startPano)) {
    return startPano;
  }

  const [firstPano] = carouselPanos;

  if (firstPano) {
    return firstPano.panoid;
  }
};
